import { useUserStore } from '../../../../modules/Auth/stores/authStore';
import DropDown from '../../molecules/Dropdown';
import { Typography } from '../../molecules/Typography';
interface ITimeline {
  items: {
    id: string;
    text: string;
    seconds: number;
  }[];
  label?: string;
  onClickItem?: (e: any) => void;
}

export default function Timeline({ items, label, onClickItem }: ITimeline) {
  const { user } = useUserStore();

  const timelineOnClick = (item: any) => {
    if (onClickItem) {
      onClickItem(item);
    }
  };

  if (!items || items.length === 0) {
    return <></>;
  }

  return (
    <div className='hidden rounded-b-md bg-color-lightest px-4 py-5 md:block'>
      <div className='flex items-center gap-5'>
        {label && (
          <Typography size={'default'} className='w-auto min-w-fit'>
            {label}
          </Typography>
        )}
        <div className='flex w-full'>
          {items?.map((item: any, index: number) => {
            const showLine = index < items.length - 1;
            return (
              <div
                key={`timeline-${item.id ?? index}`}
                className={`flex items-center ${showLine ? 'flex-1' : 'w-auto'}`}
                onClick={() => timelineOnClick(item)}
              >
                <div
                  data-tooltip-id={`timeline-item-${index}`}
                  className={`
                    border-4 h-4 
                    w-4 cursor-pointer
                    rounded-circular
                    bg-brand-color-primary-lighter
                    shrink-0
                  `}
                ></div>

                <DropDown
                  id={`timeline-item-${index}`}
                  offset={5}
                  position='top-start'
                  style={
                    user?.isDarkMode
                      ? { backgroundColor: '#000C29' }
                      : { backgroundColor: '#ffffff' }
                  }
                >
                  <Typography>{items[index]?.text}</Typography>
                </DropDown>

                {showLine && (
                  <div className='flex-1'>
                    <span className='block w-full border-t-hairline border-brand-color-primary-lighter' />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
